import {Sync} from '@client/sync'
import {
  DataObjectId,
  noBoardContainerId,
  Workflow,
  WorkflowState
} from 'yougile-model'
import {ObjUtil} from 'yougile-util'

export const getWorkflows = (taskId: DataObjectId): Workflow[] => {
  const box = Sync.getCurrentSandbox()
  const task = box.getHub(taskId)
  if (!task || task.location === noBoardContainerId) {
    return []
  }
  const column = box.getHub(task.location)
  const boardId = column.location
  const company = box.getHub(box.companyId)
  const all = company.data.workflows ?? {}

  return ObjUtil.values(all).filter(w => w.boards.includes(boardId))
}

export const getTaskWorkflowState = (taskId: DataObjectId): WorkflowState => {
  const box = Sync.getCurrentSandbox()
  const task = box.getHub(taskId)
  return task?.data?.workflowState
}
